import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import { removeLocalData } from "../../helpers/storage-helper";
import { authActions } from "../../store/auth";
import { templateAction } from "../../store/template-store";
import Loader from "../UI/loader";
import {
  AiFillCaretDown,
  AiOutlineHome,
  AiOutlineSetting,
  AiOutlineUser,
  AiOutlineCarryOut,
  AiOutlineGift,
} from "react-icons/ai";
import { FiUsers } from "react-icons/fi";

import "./header.css";
import { ImProfile } from "react-icons/im";
import { HiOutlineLogout } from "react-icons/hi";
import { BiSupport } from "react-icons/bi";
import { BsCameraVideo } from "react-icons/bs";
import useOnclickOutside from "react-cool-onclickoutside";
// import { FcBusiness } from "react-icons/fc";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { IoMagnetOutline } from "react-icons/io5";

const Header = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loader = useSelector((state) => state.auth.loader);
  const onLogout = () => {
    removeLocalData("vidamaze_user");
    removeLocalData("vidamaze_ezdata");
    dispatch(authActions.logout());
    dispatch(authActions.resetState());
    dispatch(templateAction.resetState());
    history.push("/login");
  };

  const [showActionPopup, setShowActionPopup] = useState(false);
  const [showBonusPopup,setShowBonusPopup] = useState(false);
  const access = useSelector((state) => state.auth.access);

  // console.log(access);

  const refsubMenu = useOnclickOutside(() => {
    setShowActionPopup(false);
  });

  const user_roles = useSelector((state) => state.auth.roles);
  const first_name = useSelector((state) => state.auth.first_name);

  return (
    <>
      <header id="header">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <NavLink className="navbar-brand" to="/">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                className="img-fluid"
                alt="img"
              />
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="fa fa-bars"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/dashboard"
                  >
                    <i>
                      {/* <img
                        src={`${process.env.PUBLIC_URL}/assets/images/home_ic.png`}
                        alt="img"
                      />
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/home_ic_hv.png`}
                        alt="img"
                      /> */}
                      <AiOutlineHome size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>Dashboard</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/settings"
                  >
                    <i>
                      {/* <img
                        src={`${process.env.PUBLIC_URL}/assets/images/setting.png`}
                        alt="img"
                      />
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/setting_hv.png`}
                        alt="img"
                      /> */}
                      <AiOutlineSetting size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>Settings</span>
                  </NavLink>
                </li>
                {(access.includes(8) ||
                  access.includes(81) ||
                  access.includes("7A") ||
                  access.includes("8A") ||
                  access.includes("8B") ||
                  access.includes("1a") ||
                  access.includes("9A")) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      exact
                      aria-current="page"
                      to="/dfy"
                    >
                      <i>
                        <AiOutlineCarryOut size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Agency</span>
                    </NavLink>
                  </li>
                )}
                {(access.includes("6A") ||
                  access.includes("8A") ||
                  access.includes("8B") ||
                  access.includes("5") ||
                  access.includes("1a") ||
                  access.includes("9A")) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      exact
                      aria-current="page"
                      to="/leadamaze"
                    >
                      <i>
                        <IoMagnetOutline size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Leadamaze</span>
                    </NavLink>
                  </li>
                )}
                {(access.includes("1b") ||
                  access.includes("4A") ||
                  access.includes("8A") ||
                  access.includes("8B") ||
                  access.includes("5") ||
                  access.includes("1a") ||
                  access.includes("9A")) && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/masterclass"
                  >
                    <i>
                      <AiOutlineHome size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>MasterClass</span>
                  </NavLink>
                </li>
                )}
                {(access.includes("1c") || access.includes("8A") || access.includes("8B") || access.includes("1a")) && (
                <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/bump"
                  >
                    <i>
                      <MdOutlineAlternateEmail size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>Add-on</span>
                  </NavLink>
                </li>
                )}

                {(!access.includes("5") && !access.includes("9A")) && (
                  <li className="nav-item">
                  <NavLink
                    className="nav-link h6 mb-0"
                    exact
                    aria-current="page"
                    to="/tutorials"
                  >
                    <i>
                      <BsCameraVideo size={16} />
                    </i>
                    <span style={{ verticalAlign: "middle" }}>Tutorials</span>
                  </NavLink>
                </li>
                )}

                <li className="nav-item dropdown">
                  
                  <a
                    data-bs-toggle="dropdown"
                    href="#collapseExampleBonus"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExampleBonus"
                    onClick={(e) => setShowBonusPopup(!showBonusPopup)}
                    className="nav-link mb-0 h6 dropdown-toggle"
                  >
                    <AiOutlineGift size={16} />
                    <span style={{ verticalAlign: "middle" }}>
                      Bonuses
                    </span>
                  </a>
                  <ul className="dropdown-menu">
                      <li>
                        <a href="https://engageleads.lpages.co/vidamaze-bundle-bonuses/" target="_blank" rel="noreferrer" className={"dropdown-item"}>
                          <ImProfile size={16} />
                          <span
                            className="mx-2"
                            style={{ verticalAlign: "middle" }}
                          >
                            Promised Bonuses
                          </span>
                        </a>
                      </li>
                      {/* <li>
                        <NavLink to="/leadamaze" className={"dropdown-item"}>
                          <ImProfile size={16} />
                          <span
                            className="mx-2"
                            style={{ verticalAlign: "middle" }}
                          >
                            LeadAmaze Bonuses
                          </span>
                        </NavLink>
                      </li> */}
                  </ul>
                  
                </li>

                {(user_roles.role_id === 3 || user_roles.role_id === 2) && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link h6 mb-0"
                      to="/users"
                      aria-disabled="true"
                    >
                      <i>
                        {/* <img
                          src={`${process.env.PUBLIC_URL}/assets/images/users.png`}
                          alt="img"
                        />
                        <img
                          src={`${process.env.PUBLIC_URL}/assets/images/users_hv.png`}
                          alt="img"
                        /> */}
                        <FiUsers size={16} />
                      </i>
                      <span style={{ verticalAlign: "middle" }}>Users</span>
                    </NavLink>
                  </li>
                )}
              </ul>

              <div className="last_t_r ms-auto">
                <NavLink
                  data-bs-toggle="collapse"
                  to="#collapseExample"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                  onClick={(e) => setShowActionPopup(!showActionPopup)}
                  className="text-secondary mb-0 h5"
                >
                  {/* <img
                    src={`${process.env.PUBLIC_URL}/assets/images/userImage.jpg`}
                    alt="img"
                  /> */}
                  <AiOutlineUser size={16} />
                  <span className="mx-1" style={{ verticalAlign: "middle" }}>
                    {first_name}
                  </span>
                  <AiFillCaretDown />
                </NavLink>
                <div
                  className={`collapse profile_popup ${
                    showActionPopup && "show"
                  }`}
                  id="collapseExample"
                  ref={refsubMenu}
                >
                  <div className="">
                    <ul>
                      {(!access.includes("91")) && (
                        <li>
                          <NavLink to="/profile">
                            <ImProfile size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Profile
                            </span>
                          </NavLink>
                        </li>
                      )}
                      <li>
                          <NavLink to="/tutorials">
                            <BsCameraVideo size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Tutorials
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/support">
                            <BiSupport size={16} />
                            <span
                              className="mx-2"
                              style={{ verticalAlign: "middle" }}
                            >
                              Support
                            </span>
                          </NavLink>
                        </li>
                      <li>
                        <a href="#0" onClick={onLogout}>
                          <HiOutlineLogout size={16} />
                          <span
                            className="mx-2"
                            style={{ verticalAlign: "middle" }}
                          >
                            Logout
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
      {/* <Loader /> */}
      {loader && <Loader />}
    </>
  );
};

export default Header;
